import { Checkbox } from "@mantine/core";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { StyledMedicalContent } from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalHistory.styled";

interface Props {
  inputId: string;
  initialValue?: string;
  list: { label: string; value: string }[];
}

const MedicalSelect = ({ inputId, initialValue, list }: Props) => {
  const { setValue } = useFormContext();
  const [selectedValue, setSelectedValue] = useState<string>("");

  useEffect(() => {
    const valueToSet = initialValue || "";
    if (valueToSet && valueToSet !== selectedValue) {
      setSelectedValue(valueToSet);
      if (valueToSet !== selectedValue) {
        setValue(inputId, valueToSet);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [initialValue, inputId, setValue]);

  const handleValueChange = (genderValue: string) => {
    setSelectedValue(genderValue);
    setValue(inputId, genderValue);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {list.map(option => (
        <StyledMedicalContent
          key={option.value}
          style={{
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "8px",
          }}>
          <Checkbox
            checked={selectedValue === option.value}
            onChange={() => handleValueChange(option.value)}
            size="sm"
          />
          <span style={{ fontSize: "14px" }}>{option.label}</span>
        </StyledMedicalContent>
      ))}
    </div>
  );
};

export default MedicalSelect;
